// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-group-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.message-group-container.user {
  justify-content: flex-end;
}

.message-group {
  position: relative;
  margin-right: 0;
  margin-left: 16px;
  padding: 16px 16px 16px 56px;
  text-align: left;
  font-size: 14px;
  line-height: 17px;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  width: 100%;
}

.message-group.user {
  margin-right: 16px;
  margin-left: 0;
  padding: 16px 0px 16px 16px;
  text-align: right;
}

.message-group-avatar {
  position: absolute;
  display: inline-block;
  width: 34px;
  height: 34px;
  bottom: 32px;
  transition: bottom 450ms cubic-bezier(0.23, 1, 0.32, 1);
  left: 0px;
}

.message-group-avatar img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/MessageGroup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".message-group-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n}\n\n.message-group-container.user {\n  justify-content: flex-end;\n}\n\n.message-group {\n  position: relative;\n  margin-right: 0;\n  margin-left: 16px;\n  padding: 16px 16px 16px 56px;\n  text-align: left;\n  font-size: 14px;\n  line-height: 17px;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  width: 100%;\n}\n\n.message-group.user {\n  margin-right: 16px;\n  margin-left: 0;\n  padding: 16px 0px 16px 16px;\n  text-align: right;\n}\n\n.message-group-avatar {\n  position: absolute;\n  display: inline-block;\n  width: 34px;\n  height: 34px;\n  bottom: 32px;\n  transition: bottom 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  left: 0px;\n}\n\n.message-group-avatar img {\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
